import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfSize,
  PdfBrush,
  PdfColor,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaPastel implements IColorSchema {
  readonly name = 'Pastel';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private sizeTopLine = PdfUnit.FromMillimeters(9);
  private sizeTopTitle = PdfUnit.FromMillimeters(8);
  private marginTop = PdfUnit.FromMillimeters(5);
  private paddingTop = PdfUnit.FromMillimeters(3);
  private paddingBottom = PdfUnit.FromMillimeters(5);

  private pageBackgroundColor = PdfColor.fromRgb(244, 244, 244);

  private backgroundColors: PdfColor[] = [
    PdfColor.fromRgb(249, 230, 230),
    PdfColor.fromRgb(247, 243, 217),
    PdfColor.fromRgb(219, 240, 226),
    PdfColor.fromRgb(217, 231, 247),
  ];

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    page.drawRectangle(null, new PdfBrush(this.pageBackgroundColor), rect);
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `- ${pageNumber} -`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    let left = rect.x;

    // Full-width pastel background
    const back = new PdfRect(0, rect.y, PdfSize.A4.width, rect.height);
    page.drawRectangle(
      null,
      new PdfBrush(this.backgroundColors[index % this.backgroundColors.length]),
      back
    );

    if (counter) {
      const s1 = page.measureString(counter, font);
      const r = new PdfRect(left, rect.y, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(counter, font, PdfBrush.Black, null, r, ETextAlign.Center);
      left += r.width + this.marginTop;
    }

    if (title) {
      const s1 = page.measureString(title, font);
      const r = new PdfRect(left, rect.y, 2 * this.paddingTop + s1.width, this.sizeTopTitle);
      page.drawString(title, font, PdfBrush.Black, null, r, ETextAlign.CenterLeft);
    }

    // Horizontal separator line
    page.drawLine(
      GUtil.basePen,
      new PdfPoint(rect.left, rect.y + this.sizeTopLine),
      new PdfPoint(rect.right, rect.y + this.sizeTopLine)
    );
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    page.drawRectangle(null, PdfBrush.White, rect);
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x,
      rect.y + this.sizeTopHeader,
      rect.width,
      rect.height - this.sizeTopHeader - this.paddingBottom
    );
  }
}
